window.axios = require("axios");

class WishlistObjectQf {
  constructor() {
    this.LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
    this.LOCAL_STORAGE_DELIMITER = ",";
    this.BUTTON_ACTIVE_CLASS = "active-wishlist";
    this.GRID_LOADED_CLASS = "loaded";

    this.selectors = {
      button: "[button-wishlist]",
      remove: "[data-wishlist-remove]",
      clearWishlist: ".clear-wishlist",
      grid: "[grid-wishlist]",
      productCard: ".product-card"
    };

    this.init()
  }

  init() {
    this.wishlistCount();
    this.initButtons();
    this.initGrid().then(() => {
      this.buttonCheck();
    })
  }

  buttonCheck() {
    let vm = this;
    let buttons = document.querySelectorAll(this.selectors.button);
    buttons.forEach((button) => {
      const productHandle = button.dataset.productHandle || false;
      if (vm.wishlistContains(productHandle)) {
        button.classList.add(vm.BUTTON_ACTIVE_CLASS);
      }
    })
  }

  initButtons = () => {
    let vm = this;
    document.body.addEventListener('click', function (e) {      
      // Checks to see if the target that has been clicked contains wishlist data attribute
      const button = e.target.closest(vm.selectors.button);
      const remove = e.target.closest(vm.selectors.remove);
      if (button && button.classList.contains('active-wishlist') == false) {
        e.preventDefault();
        // Creates object from selected attributes
        let attributes = {};
        if(localStorage.getItem('items')) {
          JSON.parse(localStorage.getItem('items')).forEach(attribute => {
            attributes[attribute.title] = attribute;
          });
        }
        

        const itemId = Math.floor(new Date().getTime() / 1000);

        const product = {
          id: itemId,
          handle: button.dataset.productHandle || false,
          attributes,
        };
        const productObject = Object.create(product);

        // checks to see if the data attribute for product handle exists and outputs an error if not
        if (!productObject) {
          return console.error(
            "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
          );
        } else {
          vm.updateWishlist(product);
        }

        // Grabs all wishlist buttons and adds active state
        let allButtonsForHandle = document.querySelectorAll(
          `${vm.selectors.button}[data-product-handle="${button.dataset.productHandle}"]`
        );
        if (allButtonsForHandle) {
          allButtonsForHandle.forEach((buttonAddClass) => {
            buttonAddClass.classList.toggle(vm.BUTTON_ACTIVE_CLASS);
          });
        }

        vm.wishlistCount();

      } else if (button && button.classList.contains('active-wishlist')) {
        const attributeHandle = button.dataset.productHandle;
        const newWisthlist = vm.getWishlist().filter(wishlist => wishlist.handle != attributeHandle);
        vm.setWishlist(newWisthlist);
        button.classList.remove('active-wishlist');
        vm.wishlistCount();
      } else if (remove) {

        const attributeHandle = remove.dataset.wishlistRemove;
        const newWisthlist = vm.getWishlist().filter(wishlist => wishlist.handle != attributeHandle);
        vm.setWishlist(newWisthlist);
        remove.closest('.product-card').remove();
        vm.wishlistCount();
      }

      // Checks to see if the target that has been clicked contains clear wishlist class
      const clearButton = e.target.closest(vm.selectors.clearWishlist);
      if (clearButton) {
        vm.resetWishlist();
        vm.initGrid()
      }
    });

    document.dispatchEvent(new CustomEvent("shopify-wishlist:init-buttons", {
      detail: { wishlist: vm.getWishlist() },
    }));
  };

  wishlistCount() {
    if(localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) && JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY)).length > 0) {
        document.getElementById('wishlistCount').classList.remove('is-hidden');
        const wishlistNumber = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) ? JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY)).length : 0;
        document.getElementById('wishlistCount').innerHTML = wishlistNumber;
    } else {
      document.getElementById('wishlistCount').classList.add('is-hidden');
    }
  }

  wishlistContains = (handle) => {
    const wishlist = this.getWishlist();
    const wishlistString = JSON.stringify(wishlist)
    return wishlistString.includes(handle);
  };

  getWishlist = () => {
    const wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return JSON.parse(wishlist);
    return [];
  };

  updateWishlist = (productHandle) => {
    const wishlist = this.getWishlist();
    const indexInWishlist = wishlist.indexOf(productHandle);
    if (indexInWishlist === -1) wishlist.push(productHandle);
    else wishlist.push(indexInWishlist, 1);

    return this.setWishlist(wishlist);
  };

  setWishlist = (array) => {
    const wishlist = JSON.stringify(array);
    if (array.length) {
      localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
      document.dispatchEvent(new CustomEvent("shopify-wishlist:updated", {
        detail: { wishlist: array },
      }));
    } else {
      localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
      window.log("wishlist had no length");
    }
  }

  resetWishlist = () => {
    let vm = this;
    let allWishlistButtons = document.querySelectorAll(vm.selectors.button);
    allWishlistButtons.forEach((button) => {
      button.classList.remove(vm.BUTTON_ACTIVE_CLASS);
    });
    return vm.setWishlist([]);
  };

  // Class to generate the grid in the withlist page
  initGrid = async () => {
    let vm = this;


    // This checks if the wishlist grid data attribute exits
    const grid = document.querySelector(this.selectors.grid) || false;
    if (grid) {
      grid.innerHTML = "";

      // This grabs the wishlist list from the local storage
      const wishlist = this.getWishlist();
      await wishlist.forEach(wishlistItem => {
        // This uses the handle to generate the wishlist product URL
        let productTileTemplateUrl = window.Shopify.routes.root + `products/${wishlistItem.handle}?view=card&section_id=v2-wishlist-product-card`;

        let productPrice = 0;

        axios.get(productTileTemplateUrl, {})
          .then((response) => {
            if (response.status == 200) {
              const htmlDocument = new DOMParser().parseFromString(response.data, "text/html");
              const productCard = htmlDocument.documentElement.querySelector(
                vm.selectors.productCard
              );
              
              productCard.dataset.groupId = wishlistItem.id;
              const productCardUrl = productCard.children[3].children[0].getAttribute('href');
              productCard.children[3].children[0].href = `${productCardUrl}?product=${productCard.dataset.productId}&bundle=${wishlistItem.id}&type=wishlist`;
                
              productPrice = productPrice + parseInt(productCard.dataset.productPrice);

              const wishlistItems = wishlistItem.attributes;
              if (Object.keys(wishlistItems).length > 0) {
                // productCard.classList.add('product-card-with-attributes');
                Object.keys(wishlistItems).forEach(key => {
                let attributeUrl = "";
                attributeUrl = window.Shopify.routes.root + `products/${wishlistItems[key].handle}?view=card&section_id=v2-wishlist-attribute-card`;
                axios.get(attributeUrl, {})
                  .then((response) => {
                    if (response.status == 200) {
                      const htmlDocument = new DOMParser().parseFromString(response.data, "text/html");
                      const attributeCard = htmlDocument.documentElement.querySelector(
                        vm.selectors.productCard
                      );
                      
                      productPrice = productPrice + parseInt(attributeCard.dataset.productPrice);                      
                      productCard.children[1].children[1].innerHTML = `<span>${(productPrice / 100).toLocaleString('en-GB', {style: 'currency',currency: 'GBP',})}</span>`;

                      productCard.children[2].children[1].appendChild(attributeCard);
                    }
                  });
                });
                productCard.children[2].children[0].children[0].innerHTML = `x ${Object.keys(wishlistItems).length}`;
              } else {
                productCard.children[2].remove();
              }
              
              document.querySelector(vm.selectors.grid).appendChild(
                productCard
              );
            }
          });
      })

      grid.classList.add(vm.GRID_LOADED_CLASS);

      document.dispatchEvent(new CustomEvent("shopify-wishlist:init-product-grid", {
        detail: { wishlist: wishlist },
      }));
    }
  };
}

window.WishlistObjectQf = WishlistObjectQf;